export const pagination = {
	/**
	* Gets the programmatic name of the entire locale, with the language, 
	*	country and variant separated by underbars. The Language is always lower case, 
	*	and country is always upper case. If the language is missing, 
	*	the string will begin with an underscore character. 
	*	If both the language and country fields are missing, 
	*	this function will return the empty string, 
	*	even if the variant field is filled in (you cannot have a locale with just a variant-- 
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        pagination:'Pagination',
        ten:'10',
        one:'1',
        four:'4',
        no_of_entries:'No of Entries',
        displaying_page:'Displaying page',
        of:'of ',
    },
	ar: {
        pagination:'ترقيم الصفحات',
        ten:'عشرة',
        one:'واحد',
        four:'أربعة',
        no_of_entries:'عدد الخانات',
        displaying_page:'عرض الصفحة',
        of:'من',
    }
}